/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import withModal from '../../Modal/WithModal';
import svgInline from '../../SvgInline/SvgInline';
import { ViewerPrimaryColorUserStyle } from '../../UserCustomization';

import FolderManager from '../FolderManager';
import closeIcon from '../../../shared/assets/icon-close.svg';

import './FoldersModal.css';

export function withStringIds(WrappedComponent) {
  function WithStringIds({ items, ...props }) {
    return (
      <WrappedComponent
        {...props}
        items={items.map(item => ({ ...item, _id: item._id.toString() }))}
      />
    );
  }

  WithStringIds.displayName = `withStringIds(${WrappedComponent.displayName || WrappedComponent.name})`;

  WithStringIds.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
      _id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]).isRequired,
    })).isRequired,
  };

  return WithStringIds;
}

export class FoldersModalComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.onFolderManagerStateChange = this.onFolderManagerStateChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleAction = this.handleAction.bind(this);
  }

  componentWillMount() {
    const {
      autoAction,
    } = this.props;

    if (autoAction) {
      this.handleAction();
    }
  }

  componentWillUnmount() {
    /* Area favorites list items use withFavorites instance of FoldersModal. When item is removed
      from folder on My Folders page, the component unmounts so there is no instance of FoldersModal
      available to dispatch the modal close - this checks for this condition and deactivates modal
    */
    const {
      onModalClick,
      referrer,
    } = this.props;
    if (referrer === 'withFavorites' && window.location.pathname.indexOf('favorites') > 0) {
      onModalClick();
    }
  }

  onFolderManagerStateChange(state) {
    this.setState(state);
  }

  /*
  selectType indicates if folder selection will be rendered as a dropdown to choose folder,
  a list of all folders and checkboxes to toggle added/removed or a single folder that
  can't be changed. Dropdown folder uses the original handleAction() to submit the add
  or remove function but the multiselect calls its own toggle function. This is passed
  as a prop to FolderManager to determine how to render and act
  */
  setSelectType = type => {
    switch (type) {
      case 'save':
      case 'remove':
        return 'multi';
      case 'save-all':
      case 'remove-all':
        return 'dropdown';
      case 'remove-all-favorites':
        return 'single';
      default:
        return 'dropdown';
    }
  };

  handleAction() {
    const {
      saveItems,
      removeItems,
      items,
      itemType,
      folderId,
      action,
      onModalClick,
    } = this.props;
    const fn = ['save', 'save-all'].includes(action) ? saveItems : removeItems;
    fn({ items, itemType, folderId });
    onModalClick();
  }

  handleSubmit(e) {
    e.preventDefault();
    this.handleAction();
  }

  buildModalHeading = () => {
    const { action, items, itemType } = this.props;
    const singularItemType = itemType === 'buildings' ? 'building' : 'site';
    const itemLabel = items && items.length === 1 ? items[0].name : singularItemType;
    if (['save', 'remove'].includes(action) && !this.state.adding) {
      return (
        <span>
          Toggle checkbox to Add or Remove <strong>{itemLabel}</strong> to available folders:
        </span>
      );
    } else if (this.state.adding) {
      return 'Create New Folder';
    } else if (action === 'save-all') {
      return <span>Add all {itemType} in current property list to:</span>;
    } else if (action === 'remove-all') {
      return <span>Remove all {itemType} in current property list from:</span>;
    } else if (action === 'remove-all-favorites') {
      return <span>Confirm removal of all {itemType} from folder:</span>;
    }
    return action;
  };

  render() {
    const {
      onModalClick,
      action,
      hasFolders,
      ...props
    } = this.props;

    const { adding } = this.state;
    const selectType = this.setSelectType(action);
    return (
      <div className="modal-wrapper folders-modal">
        <ViewerPrimaryColorUserStyle domStyle="backgroundColor">
          <div className="modal-header folders-modal__header">
            <h2 className="modal-title folders-modal__title">Manage Folders</h2>
            <a tabIndex="0" onClick={onModalClick}>
              <div className="modal-close folders-modal__close">
                {svgInline(closeIcon)}
              </div>
            </a>
          </div>
        </ViewerPrimaryColorUserStyle>
        { selectType === 'multi' &&
          <div className={`modal-body folders-modal__body ${['save', 'save-all', 'remove'].includes(action) && !adding ? 'folders-modal__body--selecting' : ''}`}>
            <div className="body-header">
              {this.buildModalHeading()}
            </div>
            <div style={{ marginBottom: 20 }}>
              <FolderManager {...props} mode="modal" selectType={selectType} supportsAdd={['save', 'save-all', 'remove'].includes(action)} onStateChange={this.onFolderManagerStateChange} />
            </div>
            <div style={{ marginBottom: 20 }}>
              <ViewerPrimaryColorUserStyle domStyle="backgroundColor">
                <button className="btn" onClick={onModalClick}>Done</button>
              </ViewerPrimaryColorUserStyle>
            </div>
          </div>
        }

        {selectType !== 'multi' &&
          <form className={`modal-body folders-modal__body ${['save', 'save-all', 'remove'].includes(action) && !adding ? 'folders-modal__body--selecting' : ''}`} onSubmit={this.handleSubmit} noValidate>
            <div className="body-header">
              {this.buildModalHeading()}
            </div>
            <div style={{ marginBottom: 20 }}>
              <FolderManager {...props} mode="modal" selectType={selectType} supportsAllOption supportsAdd={['save', 'save-all'].includes(action)} onStateChange={this.onFolderManagerStateChange} />
            </div>
            {
              !adding &&
              <div style={{ marginBottom: 20 }}>
                <ViewerPrimaryColorUserStyle domStyle="backgroundColor">
                  <button className="btn" disabled={!hasFolders}>{['save', 'save-all'].includes(action) ? 'Add' : 'Remove'}</button>
                </ViewerPrimaryColorUserStyle>
                <ViewerPrimaryColorUserStyle domStyle="backgroundColor">
                  <button className="btn" style={{ marginLeft: 20 }} onClick={onModalClick}>Cancel</button>
                </ViewerPrimaryColorUserStyle>
              </div>
            }
          </form>
        }
      </div>
    );
  }
}

FoldersModalComponent.propTypes = {
  // save/remove - triggered on individual properties
  // save-all/remove-all - triggered on bulk update from main Properties page
  // remove-all-favorites - triggered on Remove All button on Favorites page
  action: PropTypes.oneOf(['save', 'save-all', 'remove', 'remove-all', 'remove-all-favorites']).isRequired,
  folderId: PropTypes.string,
  autoAction: PropTypes.bool,
  hasFolders: PropTypes.bool,
  saveItems: PropTypes.func,
  removeItems: PropTypes.func,
  onModalClick: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.shape({
    _id: PropTypes.string,
  })).isRequired,
  itemType: PropTypes.string.isRequired,
  referrer: PropTypes.string,
};

export default withStringIds(withModal(FoldersModalComponent, 'folders'));



// WEBPACK FOOTER //
// ./src/components/Favorites/FoldersModal/FoldersModal.js